<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl" v-if="client">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">{{ firma }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowa faktura
    </h1>
    <h1 class="mb-8 font-bold text-3xl" v-if="client == null">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('factures')">Definicje faktur</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowa faktura
    </h1>
    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">
        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <div class="pr-6 pb-8 w-full" v-if="client">
              <text-input v-model="firma" label="Klient" disabled />
            </div>
            <div class="pr-6 pb-8 w-full" v-else>
              <multiselect-input v-model="form.client" :error="form.errors.client" label="Klient" :options="clients_opt" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" :searchable="true" />
            </div>

            <multiselect-input v-model="form.contract" :error="form.errors.contract" label="Umowa" :options="contracts" class="pr-6 pb-8 w-full" track_by="id" opt_label="number" :multiple="false" :close_on_select="true" />

            <multiselect-input v-model="form.storeroom" :error="form.errors.storeroom" label="Magazyn" :options="storerooms" class="pr-6 pb-8 w-full lg:w-1/2" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />

            <multiselect-input v-model="form.payment_method" :error="form.errors.payment_method" label="Forma płatności" :options="payment_methods" class="pr-6 pb-8 w-full lg:w-1/2" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" :searchable="true" />

            <shtax-text-area-input class="pr-6 pb-8 w-full" v-model:checked="form.notice" :error="form.errors.notice" label="Uwagi"  />

            <div class="w-full lg:w-1/2">
              Liczba dokumentów zgromadzonych przez klienta w miesiącu <b>{{ last_month }}</b> wynosi: <b>{{ liczba_dok }}</b>
            </div>
          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
            <loading-button :loading="form.processing" class="btn-shtax" type="submit">Zdefiniuj fakturę</loading-button>
          </div>
        </form>
      </div>

      <div class="mt-12 lg:mt-0 lg:px-8 w-full lg:w-1/2">
        <h3 class="mb-2 font-bold text-lg md:text-md ">
          Historia zgromadzonych przez klienta dokumentów <small class="text-gray-400">(z ostatnich 12 miesięcy)</small>
        </h3>
        <div class="mt-2 bg-white rounded shadow overflow-x-auto text-sm">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="px-3 pt-3 pb-2">Rok</th>
              <th class="px-3 pt-3 pb-2">Miesiąc</th>
              <th class="px-3 pt-3 pb-2">Liczba dokumentów</th>
            </tr>
            <tr v-for="doc in docs" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t">
                <span class="px-3 py-2 flex items-center focus:text-shtax-500">
                  {{ doc.ROK }}
                </span>
              </td>
              <td class="border-t">
                <span class="px-3 py-2 flex items-center" tabindex="-1">
                  {{ doc.MIESIAC }}
                </span>
              </td>
              <td class="border-t">
                <span class="px-3 py-2 flex items-center" tabindex="-1">
                  {{ doc.number_of_docs }}
                </span>
              </td>
            </tr>
            <tr v-if="docs.length === 0">
              <td class="border-t px-3 py-2" colspan="3">Klient nie zgromadził jeszcze żadnych dokumentów.</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Nowa faktura' },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    ShtaxTextAreaInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
    client: Object,
    clients: Array,
    contracts: Array,
    storerooms: Array,
    payment_methods: Array,
    last_month: String,
    liczba_dok: Number,
    docs: Array,
    config: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        client: this.client ? this.client : null,
        client_id: this.client ? this.client.id : null,
        contract: this.client.contract,
        storeroom: this.config.magazyn,
        payment_method: this.config.forma_platnosci,
        notice: this.config.uwagi
      }),
      disabled_number: false,
      clients_opt: this.clients ? this.clients.map(client => {return {'id':client.id,'name':client.kontrahent.NAZWA_PELNA}}) : null,
      //contracts_opt: this.contracts.map(contract => {return {'id':contract.id,'name':contract.number}}),
      //storerooms_opt: this.storerooms.map(storeroom => {return {'id':storeroom.ID_MAGAZYNU,'name':storeroom.SYMBOL +' - '+ storeroom.NAZWA}}),
      //payment_methods_opt: this.payment_methods.map(payment_method => {return {'id':payment_method.ID_FORMY,'name':payment_method.NAZWA +' ('+ payment_method.DNI_NALEZNOSCI +' dni)'}})
    }
  },
  methods: {
    store() {
      this.form.post(this.route('factures.store', this.form.client.id))
    },
  },

  computed: {
    firma() {
      return this.client.firma ? this.client.firma.NAZWA_PELNA : this.client.nazwa_pelna
    }
  }
}
</script>
